import { render, staticRenderFns } from "./GameUIContainer.vue?vue&type=template&id=40e72943&"
import script from "./GameUIContainer.vue?vue&type=script&lang=ts&"
export * from "./GameUIContainer.vue?vue&type=script&lang=ts&"
import style0 from "./GameUIContainer.vue?vue&type=style&index=0&id=40e72943&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports